// extracted by mini-css-extract-plugin
export default {"footer":"rEVd26","moreItemsText":"lvEYl1","mobileFooter":"T9RX7d","updatedMobileInterface":"JKW0yS","mobileButtonFontSize":"boPd68"};